const axios = require('axios').default;
const { API_DOMAIN } = require("../config");
const token = localStorage.getItem("auth-token");

const axiosInstance = axios.create({
  baseURL: API_DOMAIN,
  headers: { "auth-token": token },
});
module.exports = axiosInstance;